import React, { useEffect, useState } from "react";
import api from "../api";
import { SunflowerOrnament } from "../SunflowerOrnament";

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  useEffect(()=> { api.get("/gallery").then(r=>setItems(r.data)); }, []);

  const grouped = items.reduce((acc, p) => { (acc[p.category] = acc[p.category] || []).push(p); return acc; }, {});

  return (
    <div className="relative">
      <div className="absolute -top-10 -right-10 hidden md:block pointer-events-none">
        <SunflowerOrnament size={280} opacity={0.09}/>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-14 relative">
        <div className="text-center mb-12">
          <div className="tag-sun mb-3 inline-block">GALERIA</div>
          <h1 className="font-serif text-4xl sm:text-5xl">Nossos trabalhos</h1>
          <p className="text-[color:var(--ink-500)] mt-3 max-w-xl mx-auto">Uma seleção de manicures, nail art e cuidados assinados pelo Arya Studio.</p>
        </div>

        {items.length === 0 ? (
          <div className="card-arya p-14 text-center text-[color:var(--ink-500)]">A galeria será lançada em breve.</div>
        ) : (
          Object.entries(grouped).map(([cat, list]) => (
            <div key={cat} className="mb-12">
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-2">
                <span className="text-[color:var(--sun-600)]">✿</span> {cat}
              </h2>
              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
                {list.map(p => (
                  <figure key={p.photo_id} className="card-arya overflow-hidden group" data-testid={`gal-item-${p.photo_id}`}>
                    <div className="aspect-square overflow-hidden bg-[var(--cream-100)]">
                      <img src={p.image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500"/>
                    </div>
                    <figcaption className="p-4">
                      <p className="font-display font-semibold">{p.title}</p>
                      {p.description && <p className="text-xs text-[color:var(--ink-500)] mt-1">{p.description}</p>}
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
